module.exports = __webpack_public_path__ + "img/sand-dune-decal-29.e80d98d1.png";